import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Gold verified checkmark for "top" creators (premium_creator or >= 50 followers).
 * Silent for non-top creators.
 */
export default function VerifiedBadge({ gold = false, size = 14, className = "" }) {
  const color = gold ? "text-tv-accent" : "text-sky-400";
  return (
    <span
      data-testid={gold ? "verified-badge-gold" : "verified-badge"}
      title={gold ? "Top Creator" : "Verified"}
      className={`inline-flex items-center justify-center ${className}`}
    >
      <BadgeCheck
        className={`${color} drop-shadow-sm`}
        style={{ width: size, height: size }}
        strokeWidth={2.5}
        fill={gold ? "currentColor" : "none"}
      />
      {gold && (
        <BadgeCheck
          className="text-black absolute"
          style={{ width: size * 0.55, height: size * 0.55 }}
          strokeWidth={3}
        />
      )}
    </span>
  );
}
